import React from 'react'
import { connect } from 'react-redux'
import { HashRouter } from 'react-router-dom'

import FpSdk from 'forepaas/sdk'
import FpToaster from 'forepaas/toaster'
import FpLoader from 'forepaas/core-ui/loader'

import FpLoginSelector from './forepaas-extensions/client-authority-manager/FpLoginSelector'
import BrandManager from './components/BrandManager';
import { configureAmplify } from './services/amplify';
import { refreshCurrentUser } from '@/helpers/auth';
import './forepaas-extensions/client-authority-manager/styles/authentication.less'

configureAmplify();

var FpMenuLoader, FpDashboardLoader, FpGoogleAnalytics

@connect(state => ({
  store: state,
  user: state.memory.user,
}))
class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
    }

    if (FpSdk.modules.menu) {
      FpMenuLoader = FpSdk.modules.menu.FpMenuLoader
    }

    if (FpSdk.modules.dashboarding) {
      FpDashboardLoader = FpSdk.modules.dashboarding.FpDashboardLoader
    }

    if (FpSdk.modules['google-analytics']) {
      FpGoogleAnalytics = FpSdk.modules['google-analytics']
      FpGoogleAnalytics.init()
    }
  }

  componentWillMount() {
    refreshCurrentUser()
      .catch((err) => {
        console.error("error refreshCurrentUser", err);
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  renderApp() {
    return (
      <HashRouter>
        <div className='view'>
          {FpSdk.modules.menu && FpSdk.config.menu &&
            <FpMenuLoader />
          }
          {FpSdk.modules.dashboarding &&
            <div className='page'>
              <FpDashboardLoader />
            </div>
          }
        </div>
      </HashRouter>
    )
  }

  renderLogin() {
    return <FpLoginSelector />
  }

  render() {
    const Toaster = FpToaster.render()
    let rootClassName = 'root-container ' + (this.state.isAuthenticated ? 'logged' : 'not-logged')
    return (
      <div className={rootClassName}>
        <BrandManager />
        {this.state.isLoading ? <FpLoader /> : this.props.user && !this.props.user.forceChangePW ? this.renderApp() : this.renderLogin()}
        < Toaster />
      </div>
    )
  }
}

export default App
